import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IBusinessDetail } from 'src/app/interface';
import { isNil } from 'src/app/utils';

@Component({
  selector: 'app-search-items',
  templateUrl: './search-items.component.html',
  styleUrls: ['./search-items.component.scss']
})
export class SearchItemsComponent implements OnInit {

  @Input('businessDetail') businessDetail: IBusinessDetail

  classTypes = []

  constructor(
    private router: Router
  ) { }

  ngOnChanges() {
    if (!isNil(this.businessDetail)) {
      this.classTypes = this.businessDetail.deliveryMode.split(',')
    }
  }

  ngOnInit(): void {
  }

  onItemSelect() {
    this.router.navigateByUrl(`/classprofile/` + this.businessDetail.venId + `/` + this.businessDetail.id);
  }

}
